import React, { useEffect, useState } from 'react';
import { DollarSign, Menu, X, Sun, Moon, ChevronDown } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../../context/ThemeContext';
import { PossibleLogo } from '../ui/PossibleLogo';
export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();
  const {
    isDark,
    toggleTheme
  } = useTheme();
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <>
      {/* Announcement bar */}
      <div className="bg-gray-900 text-white text-xs py-2 px-4 text-center" data-id="element-885">
        <span className="bg-accent-500 text-black text-xs font-bold px-2 py-0.5 rounded mr-2" data-id="element-886">
          New
        </span>
        AI-powered financial insights now available —
        <button className="underline ml-1 hover:text-accent-400 transition-colors" data-id="element-887">
          Learn more →
        </button>
      </div>

      {/* Navbar */}
      <nav className={`sticky top-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white/95 dark:bg-dark-surface/95 backdrop-blur-md shadow-sm' : 'bg-white dark:bg-dark-surface'} border-b border-gray-200 dark:border-dark-border`} data-id="element-888">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between" data-id="element-889">
          {/* Logo */}
          <button onClick={() => navigate('/')} className="flex items-center gap-2.5 group" data-id="element-890">
            <PossibleLogo height={18} variant="color" data-id="element-891" />
          </button>

          {/* Desktop nav */}
          <div className="hidden md:flex items-center gap-6" data-id="element-892">
            {['Products', 'Features', 'Pricing', 'About'].map(item => <button key={item} className="text-sm text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white font-medium transition-colors flex items-center gap-1" data-id="element-893">
                {item} {item !== 'About' && <ChevronDown size={13} data-id="element-894" />}
              </button>)}
          </div>

          {/* Right actions */}
          <div className="hidden md:flex items-center gap-3" data-id="element-895">
            <button onClick={toggleTheme} className="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-dark-hover text-gray-500 dark:text-gray-400 transition-colors" data-id="element-896">
              {isDark ? <Sun size={17} data-id="element-897" /> : <Moon size={17} data-id="element-898" />}
            </button>
            <button onClick={() => navigate('/login')} className="text-sm font-medium text-gray-700 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white px-4 py-2 rounded-xl border border-gray-200 dark:border-dark-border hover:border-gray-300 dark:hover:border-gray-600 transition-colors" data-id="element-899">
              Log in
            </button>
            <button onClick={() => navigate('/signup')} className="text-sm font-semibold bg-accent-500 hover:bg-accent-600 text-black px-4 py-2 rounded-xl transition-colors flex items-center gap-1.5" data-id="element-900">
              Get started ↗
            </button>
          </div>

          {/* Mobile menu button */}
          <button onClick={() => setMobileOpen(!mobileOpen)} className="md:hidden p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-dark-hover" data-id="element-901">
            {mobileOpen ? <X size={20} data-id="element-902" /> : <Menu size={20} data-id="element-903" />}
          </button>
        </div>

        {/* Mobile menu */}
        {mobileOpen && <div className="md:hidden border-t border-gray-200 dark:border-dark-border bg-white dark:bg-dark-surface px-4 py-4 space-y-3" data-id="element-904">
            {['Products', 'Features', 'Pricing', 'About'].map(item => <button key={item} className="block w-full text-left text-sm text-gray-700 dark:text-gray-300 py-2 font-medium" data-id="element-905">
                {item}
              </button>)}
            <div className="flex gap-3 pt-2" data-id="element-906">
              <button onClick={() => navigate('/login')} className="flex-1 text-sm font-medium py-2 rounded-xl border border-gray-200 dark:border-dark-border text-center" data-id="element-907">
                Log in
              </button>
              <button onClick={() => navigate('/signup')} className="flex-1 text-sm font-semibold py-2 rounded-xl bg-accent-500 text-black text-center" data-id="element-908">
                Get started
              </button>
            </div>
          </div>}
      </nav>
    </>;
}